import { Validator } from '@adaptiva/core/collections';
import { DisplayValue, IResponsiveConfiguration } from '@adaptiva/core/common';
import { EInterferingProcessBehavior, InstallTimeProperties, MetadataSerialization } from '@adaptiva/metadata/common';
import { ChangeDetectionStrategy, Component, effect, EffectRef, input, signal, Signal, WritableSignal } from '@angular/core';
import { BaseAuthoringPropertiesComponent } from '../base-authoring-component';

@Component({
	standalone: false,
	selector: 'ada-install-time-properties',
	templateUrl: './install-time-properties.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class InstallTimePropertiesComponent extends BaseAuthoringPropertiesComponent<InstallTimeProperties> {

	public propertyConstructor: MetadataSerialization.Deserializable<InstallTimeProperties> = InstallTimeProperties;

	protected readonly keyValidators: Validator<string>[] = [(_key: string) => []];

	protected readonly interferingProcessOptions: DisplayValue<EInterferingProcessBehavior>[] = EInterferingProcessBehavior.displayOptions();

	protected readonly interferingProcessResponsiveConfig: IResponsiveConfiguration = { SM: 2, MD: 2, LG: 2, XL: 2 };

	protected readonly interferingProcessKeyOptions: WritableSignal<DisplayValue<string>[]> = signal([]);

	protected readonly installProcesses: Signal<string[]> = input([]);

	protected readonly installProcessEffect: EffectRef = effect(() => {
		const _processes: string[] = this.installProcesses();

		this.interferingProcessKeyOptions.set(_processes.map((p) => new DisplayValue(p, p)));
	});

}
